import React from 'react'
import StaticImage from './shared/StaticImage';
import logoImage from '../images/logo.png';
import SwapBackgroundShapes from './SwapBackgroundShapes';

export default function LocationResctrictionBarrierScreen({
  countryName
}: {
  countryName?: string | null;
}) {
  return (
    <div className="fixed inset-0 flex justify-center items-center bg-grey-900 z-[9999]">
      <SwapBackgroundShapes />
      <div className="bg-white/10 text-white p-6 lg:p-8 py-8 lg:py-12 rounded-lg shadow-lg w-[600px] max-w-[90%] text-center">
        <StaticImage
          src={logoImage}
          alt=""
          height={28}
          className={`mb-8`}
        />
        <h2 className="text-2xl mb-8 text-primary-400">Access Restricted</h2>
        <p className="mb-6 leading-relaxed text-sm lg:text-base">
          We're sorry, but access to Olympex is not available in your region due to regulatory restrictions.
        </p>
        <p className="mb-6 leading-relaxed text-sm lg:text-base">
          The use of the Platform is prohibited for individuals or entities based in countries or territories 
          subject to sanctions or restrictions imposed by international organizations, including, but not limited to, 
          sanctions from the Office of Foreign Assets Control (OFAC) of the United States, the European Union (EU), 
          the United Nations (UN), and the Financial Action Task Force (FATF).
        </p>
        {countryName && (
          <p className="leading-relaxed text-sm lg:text-base">
            Your current location appears to be: <strong className="text-secondary-400">{countryName}</strong>
          </p>
        )}
      </div>
    </div>
  );
}
